/* eslint-disable */
/* eslint-disable jsx-a11y/label-has-associated-control */

import React, { useLayoutEffect, useState, useContext, useRef } from 'react';
import { IoIosCloseCircleOutline } from 'react-icons/io';
import { BsImage } from 'react-icons/bs';
import { useTranslation } from 'react-i18next';

import { color } from 'styles/colors';
import LoadContext from 'hooks/useLoad';
import { ImgRespProps } from 'types/ImgRespProps';
import { saveImg } from './reqs';
import * as S from './styles';

interface SelectInputImgProps {
  getImg: React.Dispatch<React.SetStateAction<ImgRespProps | null>>;
  initialImage: string;
  isActive?: boolean;
}

export default function SelectInputImg({
  getImg,
  initialImage,
  isActive = true,
}: SelectInputImgProps) {
  const { t } = useTranslation();
  const { setIsLoad, setText } = useContext(LoadContext);
  const [imageSavedOnBack, setImageSavedOnBack] = useState<ImgRespProps | null>(
    null,
  );
  const [imageOffline, setImageOffline] = useState('');
  const inputRef = useRef<HTMLInputElement>(null); // Ref para o input

  async function savePhoto(file: any) {
    let isSuccess = false;

    setIsLoad(true);
    setText(t('selectInputImg.savingImg'));
    const img = await saveImg(file.target.files[0]);
    setIsLoad(false);

    if (img !== null) {
      setImageSavedOnBack(img);
      isSuccess = true;
    }

    return isSuccess;
  }

  const handleImageOffline = (event: any) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        if (typeof reader.result === 'string') setImageOffline(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  useLayoutEffect(() => {
    if (imageSavedOnBack !== null) {
      getImg(imageSavedOnBack);
    }
  }, [imageSavedOnBack]);

  useLayoutEffect(() => {
    if (initialImage !== null) {
      setImageOffline(initialImage);
    }
  }, []);

  return (
    <S.inputImg>
      <input
        ref={inputRef} // Referência para o input
        type="file"
        name="iconeInput"
        id="iconeInput"
        accept="image/png, image/jpeg, image/jpg"
        onChange={async event => {
          if (event.target.files!.length > 0) {
            const isSuccess = await savePhoto(event);

            if (isSuccess) {
              handleImageOffline(event);
              inputRef.current!.value = ''; // Limpa o valor do input após o upload
            }
          }
        }}
      />

      <S.labelWithImage isActive={isActive}>
        {imageOffline !== null &&
        imageOffline !== null &&
        imageOffline !== undefined &&
        imageOffline !== '' ? (
          <S.img>
            <img src={imageOffline} alt="ícone" />
          </S.img>
        ) : (
          <BsImage style={{ color: color.interface.lightGray }} />
        )}
        <div>
          <label htmlFor={`${isActive ? 'iconeInput' : ''}`}>
            {t('customTags.choiceAimg')}
          </label>
          {imageOffline && (
            <IoIosCloseCircleOutline
              onClick={() => {
                setImageOffline('');
                setImageSavedOnBack(null);
                getImg(null);
                if (inputRef.current) inputRef.current.value = ''; // Reseta o valor do input
              }}
            />
          )}
        </div>
      </S.labelWithImage>
    </S.inputImg>
  );
}
